import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PutAwayListRead } from '../../entities/put-away-list.dto';

@Injectable()
export class PutAwayListStore extends AbstractEntityStore<PutAwayListRead> {
    constructor() {
        super(PFWmsEntities.PutAwayList);
    }
}
